import {isBoolean} from "lodash/lang";

const namespaced = true

const state = {
    isLoaded: false,
    favoritesIds: {
        complexes: [],
        properties: []
    }
}

const getters = {
    isLoaded: (state) => state.isLoaded,
    favoritesIds: (state) => state.favoritesIds,
}

const mutations = {
    index: (state, payload) => {
        if (payload && typeof payload === 'object') {
            state.favoritesIds = payload;
        }
    },
    setIsLoaded: (state, payload) => {
        isBoolean(payload) && (state.isLoaded = payload)
    }
}

const actions = {
    index: async ({ commit }) => {
        try {
            commit('setIsLoaded', false)
            const response = await storage.getItem()
            commit('index', response)
            commit('setIsLoaded', true)
            return state.favoritesIds
        } catch (e) {
            console.error(e)
        }
    },

    store: async ({ commit, state, dispatch }, params) => {
        try {
            if ((params.isComplex && state.favoritesIds.complexes.includes(params.id)) || (!params.isComplex && state.favoritesIds.properties.includes(params.id))) {
                return await dispatch('delete', params)
            } else {
                let newList = {
                    ...state.favoritesIds,
                    [params.isComplex ? 'complexes' : 'properties']: [...state.favoritesIds[params.isComplex ? 'complexes' : 'properties'], params.id]
                };
                storage.setItem(newList)
                commit('index', newList)
                if (window.sendEvent) {
                    sendEvent('key_click_favorite',{})
                }
                return {
                    message: 'Недвижимость успешно добавлена в "избранное"'
                }
            }
        } catch (e) {
            console.error(e)
        }
    },

    delete: async ({ commit, state, dispatch }, params) => {
        try {
            const newFavoritesList = {
                ...state.favoritesIds,
                [params.isComplex ? 'complexes' : 'properties']: state.favoritesIds[params.isComplex ? 'complexes' : 'properties'].filter(i => i !== params.id)
            };
            storage.setItem(newFavoritesList)
            commit('index', newFavoritesList)
            return {
                message: 'Недвижимость успешно удалена из "избранное"'
            }
        } catch (e) {
            console.error(e)
        }
    },

    deleteAll: async ({ commit, dispatch }) => {
        try {
            const emptyFavorites = {
                complexes: [],
                properties: []
            };
            storage.setItem(emptyFavorites)
            commit('index', emptyFavorites)
            return {
                message: 'Вся недвижимость успешно удалена из "избранное"'
            }
        } catch (e) {
            console.error(e)
        }
    }
}

const storage = {
    setItem: (objectItem) => {
        if (objectItem && typeof objectItem === 'object') {
            window.localStorage.setItem('favorites', JSON.stringify(objectItem))
        } else {
            console.error('Error for storage non-object item in local storage')
        }
    },
    getItem: () => {
        const list = JSON.parse(window.localStorage.getItem('favorites'))
        if (list && typeof list === 'object' && 'complexes' in list && 'properties' in list) {
            return list
        } else {
            console.error('Error for get favorites from local storage. Item must be an object with complexes and properties arrays')
            const emptyFavorites = {
                complexes: [],
                properties: []
            };
            storage.setItem(emptyFavorites)
            return emptyFavorites
        }
    }
}

export default {
    mutations,
    actions,
    state,
    getters,
    namespaced,
}
